import React from "react";
import Modal from "../../Modal/Modal";
import ModalContent from "../../Modal/ModalContent";
import BenefitsCardImage from "./components/BenefitsCardImage";
import BenefitsCardInfo from "./components/BenefitsCardInfo";

export default function BenefitsCard({
  displayedBenefits,
  handleModalOpen,
  handleModalClose,
  showModal,
  modalId,
}) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-6 md:gap-8 place-items-center max-w-5xl mx-auto">
      {displayedBenefits?.map((item, i) => (
        <React.Fragment key={i}>
          <div
            className=" rounded-lg card border p-4 sm:p-6 lg:p-8 group hover:text-white cursor-pointer"
            onClick={() => handleModalOpen(item._id)}
          >
            <BenefitsCardImage item={item} />
            <BenefitsCardInfo item={item} handleModalOpen={handleModalOpen} />
          </div>

          {modalId === item?._id && showModal && (
            <Modal handleClose={handleModalClose}>
              <ModalContent item={item} />
            </Modal>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
